import { render, staticRenderFns } from "./dropdown-select.vue?vue&type=template&id=54decc91&scoped=true&"
import script from "./dropdown-select.vue?vue&type=script&lang=js&"
export * from "./dropdown-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54decc91",
  null
  
)

export default component.exports